define('boxes/controllers/withdraw-controller',['jquery', 'boxes/controllers/box-controller', 'boxes/pending-withdraws-box', 'boxes/email-verification-box', 'boxes/mobile-verification-box', 'boxes/withdraw-box', 'boxes/upload-documents-box', 'boxes/withdraw-result-box', 'payment/getPaymentResult', 'boxes/controllers/login-controller', 'all/player/session'], function ($, boxController, pendingWithdrawsBox, emailVerification, mobileVerification, withdrawBox, uploadDocumentsBox, withdrawResultBox, getPaymentResult, loginController, session) {
    'use strict';
    var controller = boxController.create('.withdraw.controller');

    function start() {

		$.ajax({
			type: 'post',
			url: '/PaymentFormDataService/formEvent/playerEnterForm',
			data: JSON.stringify({deposit: false, mobileDevice: false}),
			contentType: "application/json",
			success: function (data) {
				console.info('player entered withdraw form');
			}
		});

        getPaymentResult.start(controller);
        controller.start(setup);
        return controller;
    }

    function setup() {
        var $boxes = controller.find('.boxes');
        controller.setBoxes([
            pendingWithdrawsBox.create($boxes.find('.box.pending-withdraws.withdraw-type'), controller),
            emailVerification.create($boxes.find('.box.email-verification'), controller, 'withdraw'),
            mobileVerification.create($boxes.find('.box.mobile-verification'), controller, 'withdraw'),
            withdrawBox.create($boxes.find('.box.withdraw'), controller),
            uploadDocumentsBox.create($boxes.find('.box.upload-documents'), controller),
            withdrawResultBox.create($boxes.find('.box.withdraw-result'), controller),
            pendingWithdrawsBox.create($boxes.find('.box.pending-withdraws.progress'), controller, true)
        ]);
    }

    var startWithdrawClass = {
        createInstance: function (parameters) {
            var withdraw = {
                startWithdraw: function () {
                    var $withdrawController = start();
                    hideLicenceAboutUs();
                    return $withdrawController;
                },
                start: function () {
                    if (session.authenticated) {
                        return withdraw.startWithdraw();
                    } else {
                        return loginController.startLoginClass.createInstance(undefined, withdraw.startWithdraw).start(function(){
                            // The close when login done is here empty since we immediately want to continue with startWithdraw function.
                        });
                    }
                },
                args: function () {
                    return undefined;
                }
            };
            return withdraw;
        },
        createHashTag: function() {
            return this.baseHashTag;
        },
        baseHashTag: 'withdraw'
    };

    function hideLicenceAboutUs() {
        var $MGAlogo = $('#start-bottom-menu').find('.logos');
        $MGAlogo.hide();
        $MGAlogo.next().hide();
    }

    return {
        start: start,
        startWithdrawClass: startWithdrawClass
    };
});

